import React, {Component} from 'react'
import propTypes from 'prop-types'
import {parseCssSelector} from 'helpers/css'

class _Node extends Component {

  gerNodeClassName = () => {
    const {node, index, totalNodes} = this.props
    const nodeClassNames = ['treeView-container']

    if (node)
      nodeClassNames.push(parseCssSelector(node.label))

    if (index === 0)
      nodeClassNames.push('root')

    if (totalNodes === 0)
      nodeClassNames.push('empty')

    return nodeClassNames.join(' ')
  }

  render () {
    const {nodeEl, nodesClass, children} = this.props
    return (
        <div className={this.gerNodeClassName()}>
          {nodeEl}
          <div className={nodesClass}>
            {children}
          </div>
        </div>
    )
  }
}


_Node.propTypes = {
  node: propTypes.object,
  nodeEl: propTypes.node.isRequired,
  totalNodes: propTypes.number,
  index: propTypes.number,
  children: propTypes.node,
  nodesClass: propTypes.string.isRequired,
}

_Node.defaultProps = {
  totalNodes: 0,
}

export default _Node